import { FC } from 'react';

import { Badge, Container, Typography } from '@mui/material';
import {
  GridCallbackDetails,
  GridFilterModel,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid';

import FuturesTradesGrid from '../FuturesTradesGrid/FuturesTradesGrid';

export interface FuturesTradesDisplayProps {
  userName: string;
  listQuery: any;
  paginationModel?: GridPaginationModel;
  setPaginationModel?: (model: GridPaginationModel, details: GridCallbackDetails) => void;
  onSortModelChange?: (model: GridSortModel, details: GridCallbackDetails) => void;
  onFilterModelChange?: (model: GridFilterModel, details: GridCallbackDetails<'filter'>) => void;
  onNewButtonClick: () => void;
  onEditButtonClick: (id: string) => void;
  onBrokerSwapButtonClick: () => void;
  onExportButtonClick: (onFinish: () => void) => void;
}

const PositionEntriesDisplay: FC<FuturesTradesDisplayProps> = ({
  userName,
  listQuery,
  paginationModel,
  setPaginationModel,
  onSortModelChange,
  onFilterModelChange,
  onNewButtonClick,
  onEditButtonClick,
  onBrokerSwapButtonClick,
  onExportButtonClick,
}) => {
  return (
    <>
      <Container maxWidth={false}>
        <Typography variant="h2" mb="0.5em" role="heading">
          <Badge color="secondary">Futures Trades</Badge>
        </Typography>
        <Typography paragraph />
        <FuturesTradesGrid
          userName={userName}
          listQuery={listQuery}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          onSortModelChange={onSortModelChange}
          onFilterModelChange={onFilterModelChange}
          onNewButtonClick={onNewButtonClick}
          onEditButtonClick={onEditButtonClick}
          onBrokerSwapButtonClick={onBrokerSwapButtonClick}
          onExportButtonClick={onExportButtonClick}
        ></FuturesTradesGrid>
      </Container>
    </>
  );
};

export default PositionEntriesDisplay;
